import React from 'react'
import {Col, Row, Typography} from 'antd'

import TaxRadio from './TaxRadio'
import {connect} from "react-redux";

const {Title} = Typography

@connect((state) => ({
    artistId: state.user.info.artistId,
    email: state.user.info.email,
}))
class Taxes extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <Row justify='space-around' gutter={{xs: 8, sm: 16, md: 24}} wrap={true} style={{marginTop: 12}}>
                <Col span={24}>
                    <Title>Tax Document</Title>
                    <TaxRadio artistId={this.props.artistId} email={this.props.email}></TaxRadio>
                </Col>
            </Row>
        )
    }
}

export default Taxes
